// removed by extract-text-webpack-plugin
module.exports = {"thead":"thead-3K_NO"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-header/table-header.less
 ** module id = 215
 ** module chunks = 0
 **/